<template>
  <div class="p-movies__outerwrapper">
    <section class="p-movies__header-container">
      <div class="container">
        <div class="p-movies__header">
          <div class="p-movies__header__mobile-filters">
            <PlayingNowFilters
              key="mobile-exposed-PlayingNowFilters"
              :where-do-you-want="''"
              :what-do-you-want="dictionary.whatDoYouWant"
              :clear-filters="dictionary.clearFilter"
              :all-genres="dictionary.allGenres"
              :placeholders="filterPlaceholders"
              :selected-filters="selectedFilters"
              :show-filters="showFilters"
              :filters="filtersData"
              :has-dates="false"
              :has-genres="false"
              @filter-changed="updateSelectedFilters"
              @reset-filters="resetMoviesFilters"></PlayingNowFilters>

            <button
              type="button"
              class="s-playing-now__filters-btn"
              @click="() => (showMobileFiltersModal = true)"></button>
          </div>
        </div>
      </div>
    </section>

    <section class="p-movies s-strip">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-2 col-xl-2 p-movies__right-col">
            <Sticky>
              <PlayingNowFilters
                key="desktop-PlayingNowFilters"
                :where-do-you-want="''"
                :what-do-you-want="dictionary.whatDoYouWant"
                :clear-filters="dictionary.clearFilter"
                :all-genres="dictionary.allGenres"
                :placeholders="filterPlaceholders"
                :selected-filters="selectedFilters"
                :show-filters="showFilters"
                :filters="filtersData"
                :has-dates="false"
                @filter-changed="updateSelectedFilters"
                @reset-filters="resetMoviesFilters"></PlayingNowFilters>
            </Sticky>
          </div>
          <div class="col-12 col-lg-9 offset-lg-1 p-0">
            <ComingSoonCardAndNotification
              v-for="record in filteredRecords"
              :key="`div-${record.id}`">
              <template #card="props">
                <ComingSoonCard
                  :key="`coming-soon-card-${record.id}`"
                  :class="props.isOpened ? 'open' : ''"
                  :record-id="record.id"
                  :title="record.title"
                  :subtitle="record.subTitle"
                  :desc="record.desc"
                  :thumb="record.thumb"
                  :img="record.img"
                  :pg="record.pg"
                  :due="record.due"
                  :duration="record.dur"
                  :dolby="record.dolby"
                  :three-dimensions="record.threeDimensions"
                  :imax="record.imax"
                  :imax3D="record.imax3D"
                  :sphera="false"
                  :genres="recordGenres(record)"
                  :url="record.url"
                  :dictionary="dictionary"
                  @notify="props.toggle()"
                  @notify-device="openReminderDevices"></ComingSoonCard>
              </template>

              <template #notify>
                <MovieReminder
                  v-if="record && record.due"
                  :key="`movie-reminder-set-${record.id}`"
                  :start="configuration.now"
                  :dictionary="notifyDictionary"
                  :configuration="configuration"
                  :due="record.due"
                  :movie-id="record.movieId"></MovieReminder>
              </template>
            </ComingSoonCardAndNotification>
          </div>
        </div>
      </div>
    </section>

    <ModalOverlay
      key="filter-modal"
      v-model="showMobileFiltersModal"
      size="player">
      <template #header>
        <i class="icon-filters"></i>
        <div class="b-pop-up__header__title">{{ dictionary.filters }}</div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <PlayingNowFilters
            key="mobile-overlay-PlayingNowFilters"
            :where-do-you-want="''"
            :what-do-you-want="dictionary.whatDoYouWant"
            :clear-filters="dictionary.clearFilter"
            :all-genres="dictionary.allGenres"
            :placeholders="filterPlaceholders"
            :selected-filters="selectedFilters"
            :show-filters="showFilters"
            :filters="filtersData"
            :has-dates="false"
            @filter-changed="updateSelectedFilters"></PlayingNowFilters>

          <div class="b-pop-up__btn-area">
            <button
              type="submit"
              class="b-pop-up__btn-mobile"
              @click="closeFilterModal">
              {{ dictionary.result }}
            </button>
            <button
              type="reset"
              class="b-pop-up__btn-reset"
              @click="resetMoviesFilters">
              {{ dictionary.clearFilter }}
            </button>
          </div>
        </div>
      </template>
    </ModalOverlay>

    <ModalOverlay key="reminder-modal" v-model="showReminderModal">
      <template #header>
        <i class="icon-camera"></i>
        <div class="b-pop-up__header__title">{{ dictionary.notify }}</div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <MovieReminder
            v-if="selectedRecord && selectedRecord.due"
            :key="`reminder-modal-${selectedRecord.id}`"
            :start="configuration.now"
            :dictionary="notifyDictionary"
            :configuration="configuration"
            :due="selectedRecord.due"
            :movie-id="selectedRecord.movieId"
            :mobile-ui-config="{
              mainClass: '',
              showTitle: false,
              showMobileTitle: true,
            }"
            :selected-movie="selectedRecord" />
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  watch,
} from 'vue'
import ComingSoonCardAndNotification from '../components/ComingSoonCardAndNotification.vue'
import ComingSoonCard from '../components/ComingSoonCard.vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import PlayingNowFilters from '../components/PlayingNowFilters.vue'
import MovieReminder from '../components/MovieReminder.vue'
import useViewport from '../../features/viewport'
import Sticky from '../components/UI/Sticky.vue'

const { desktop } = useViewport()
import { getData, moveWindowToObj } from '../../lib/lib'
import jquery from 'jquery'
const {
  filters,
  records: movies,
  dictionary,
  configuration,
  notifyDictionary,
} = getData('comingSoonPageData')

watch(desktop, () => {
  if (desktop.value) {
    closeFilterModal()
  }
})

const records = ref([])
const filteredRecords = ref([])
const filtersData = ref({})
const filtersDataFiltered = ref({})

const selectedFiltersIniValue = {
  screenTypes: 'All',
  genres: [],
}

const selectedFilters = ref({ ...selectedFiltersIniValue })
const genres = ref([])
const showMobileFiltersModal = ref(false)

const searchMovieTitle = ref('')
const moviesFiltersData = ref([])

const showFilters = computed(() => {
  return ['screenTypes']
})

const placeholderSreenAttr = dictionary.placeholderSreenAttr
  ? dictionary.placeholderSreenAttr
  : 'All'

const filterPlaceholders = computed(() => {
  return [placeholderSreenAttr]
})

const closeFilterModal = () => {
  showMobileFiltersModal.value = false
}

onBeforeMount(() => {
  genres.value = [...filters.genres]
  records.value = movies
  filtersData.value = { ...filters }
  filtersDataFiltered.value = { ...filters }
  filteredRecords.value = movies
  moviesFiltersData.value = filters.movies
})

onMounted(() => {
  const selectedGenres = filters.genres
    .filter((g) => g.isSelected)
    .map((g) => g.value)
  selectedFilters.value = { ...selectedFiltersIniValue, genres: selectedGenres }
  filterChanged(selectedFilters.value, false)
})

const recordGenres = (record) => {
  return [record.genre]
}

const filterChanged = async (filters, scroll = true) => {
  if (Object.values(filters).every((filter) => filter === 'All')) {
    filteredRecords.value = records.value
  } else {
    filteredRecords.value = filterMoviesData(filters)
  }
  await nextTick()
  if (scroll) {
    moveWindowToObj(jquery('.p-movies__outerwrapper'))
  }
}

const filterMoviesData = (filters) => {
  const filteredRecords = records.value.filter((record) => {
    const screenTypeMatch =
      filters.screenTypes === 'All' ||
      record.screenTypes.includes(filters.screenTypes)

    const genreMatch =
      filters.genres.length === 0 || filters.genres.includes(record.genreId)

    return screenTypeMatch && genreMatch
  })

  return filteredRecords
}

const resetMoviesFilters = () => {
  resetMoviesFiltersOnly()
  emptyInput()
  filterChanged(selectedFilters.value)
}

const resetMoviesFiltersOnly = () => {
  selectedFilters.value = { ...selectedFiltersIniValue }
}

const emptyInput = () => {
  searchMovieTitle.value = ''
}

const updateSelectedFilters = (filters) => {
  selectedFilters.value = { ...filters }

  emptyInput()

  filterChanged(filters)
}

// modal reminder
let selectedRecord = reactive({})
const showReminderModal = ref(false)

const openReminderDevices = (recordId) => {
  const record = records.value.find((record) => record.id === recordId)
  selectedRecord = reactive({ ...record })

  showReminderModal.value = true
}
</script>
